module.exports = __webpack_public_path__ + "static/media/wallfinishes_allImpact_60y_y.bd030784.csv";